import { commonConstants } from '../constants';

export const httpHelper = {
    getApiUrl,
    getReq,
    postReq,
    putReq,
    deleteReq
};

function getApiUrl() {
    return commonConstants.API_URL[commonConstants.MODE];
}

function getReq(querystring, headerOptions) {
    const requestOptions = {
        method: 'GET',
        headers: headerOptions
    };
    return httpReq(querystring, requestOptions);
}

function postReq(querystring, data, headerOptions) {
    const requestOptions = {
        method: 'POST',
        headers: headerOptions,
        body: JSON.stringify(data)
    };
    return httpReq(querystring, requestOptions);
}

function putReq(querystring, data, headerOptions) {
    const requestOptions = {
        method: 'PUT',
        headers: headerOptions,
        body: JSON.stringify(data)
    };
    return httpReq(querystring, requestOptions);
}

// prefixed function name with underscore because delete is a reserved word in javascript
function deleteReq(querystring, headerOptions) {
    const requestOptions = {
        method: 'DELETE',
        headers: headerOptions
    };
    return httpReq(querystring, requestOptions);
}

function httpReq(querystring, requestOptions){
    /* try{
        return fetch(httpHelper.getApiUrl()+querystring, requestOptions);
    }catch(e){
        console.log(e);
        return Promise.reject(e);
    } */

    return fetch(httpHelper.getApiUrl()+querystring, requestOptions)
    .then((response) => {
        /* if (!response.ok) {
            response.text().then(text => {
                const data = text && JSON.parse(text);
                const error = (data && data.message) || response.statusText;
                
                return Promise.reject(error);
            });
        } */
        if (!response.ok) {
            return Promise.reject('오류가 발생하였습니다.');
        }

        return response;
    });
}
